import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { environment } from '../../../../environments/environment';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (
          event instanceof HttpResponse &&
          req.url.includes('/api') &&
          event?.body?.version
        ) {
          const apiVersion = event.body?.version; // Adjust based on your API structure
          if (apiVersion && apiVersion !== environment.VERSION) {
            window.location.reload();
          }
        }
      })
    );
  }
}
